import React from 'react';
import { Brain, Zap, ChevronDown } from 'lucide-react';

const ModelSelector = ({
  selectedModel,
  setSelectedModel,
  showModelSelector,
  setShowModelSelector,
  isLoading,
  isNavbar = false
}) => {
  const currentModelIcon = selectedModel === 'claude' ? <Brain className="w-4 h-4" /> : <Zap className="w-4 h-4" />;
  const currentModelName = selectedModel === 'claude' ? 'Sonnet 4.5' : 'GPT-4.1';

  const handleModelChange = (model) => {
    setSelectedModel(model);
    setShowModelSelector(false);
  };

  // Versión para navbar
  if (isNavbar) {
    return (
      <div className="model-selector-navbar">
        <button
          onClick={() => setShowModelSelector(!showModelSelector)}
          className="navbar-model-button"
          disabled={isLoading}
        >
          <span className="navbar-model-name">{currentModelName}</span>
          <ChevronDown className="w-3 h-3" />
        </button>

        {showModelSelector && (
          <div className="navbar-model-menu">
            <button
              onClick={() => handleModelChange('claude')}
              className={`navbar-model-option ${selectedModel === 'claude' ? 'active' : ''}`}
            >
              <Brain className="w-4 h-4" />
              <span>Claude Sonnet 4.5</span>
            </button>

            <button
              onClick={() => handleModelChange('gpt4')}
              className={`navbar-model-option ${selectedModel === 'gpt4' ? 'active' : ''}`}
            >
              <Zap className="w-4 h-4" />
              <span>GPT-4.1 Turbo</span>
            </button>
          </div>
        )}
      </div>
    );
  }

  // Versión original para input (si es necesario)
  return (
    <div className="model-selector-inline">
      <button
        onClick={() => setShowModelSelector(!showModelSelector)}
        className="control-button model-toggle"
        disabled={isLoading}
        title={`Modelo actual: ${currentModelName}`}
      >
        {currentModelIcon}
        <ChevronDown className="w-3 h-3" />
      </button>

      {showModelSelector && (
        <div className="model-menu">
          <button
            onClick={() => handleModelChange('claude')}
            className={`model-option ${selectedModel === 'claude' ? 'active' : ''}`}
          >
            <Brain className="w-4 h-4" />
            <div className="model-info">
              <div className="model-name">Claude Sonnet 4.5</div>
              <div className="model-desc">Análisis preciso</div>
            </div>
          </button>

          <button
            onClick={() => handleModelChange('gpt4')}
            className={`model-option ${selectedModel === 'gpt4' ? 'active' : ''}`}
          >
            <Zap className="w-4 h-4" />
            <div className="model-info">
              <div className="model-name">GPT-4.1 Turbo</div>
              <div className="model-desc">Respuestas detalladas</div>
            </div>
          </button>
        </div>
      )}
    </div>
  );
};

export default ModelSelector;
